export class ModalModelOptions {
    id: string;
    captionHeading: any;
    bodyMessage: any;
    button1: any;
    button2: any;
    showInput: boolean;
    saveAs: string;
}



// WEBPACK FOOTER //
// ./src/app/components/modals/modals.model.ts